import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import notification from './modules/notification'
import states from './modules/states'
import employee from './modules/employee'
import languages from './modules/languages'
import paymentPlans from './modules/paymentPlans'

import abilityUpdater from './plugins/abilityUpdater'

Vue.use(Vuex)

export default new Vuex.Store({

  plugins: [
    abilityUpdater
  ],

  modules: {
    employee,
    user,
    languages,
    notification,
    states,
    paymentPlans
  }
})
